const getDashboard = (dashboardData, data) => {
  if (Object.keys(data).length === 0) {
    return [];
  }

  return Object.keys(data)
    .map((key) => {
      if (!data[key]) {
        return null;
      }

      const dahboard = dashboardData.filter((item) => {
        return item.codes === key;
      })[0];

      if (dahboard === undefined) return null;

      return {
        title: dahboard.title,
        value: appendBeforeAfter(dahboard, data[key]),
        measure: dahboard.measure !== null ? ` (${dahboard.measure})` : "",
      };
    })
    .filter((x) => {
      return x !== null;
    });
};

const appendBeforeAfter = (param, value) => {
  const valueBefore = !!param.valueBefore ? `${param.valueBefore} ` : "";
  const valueAfter = !!param.valueAfter ? ` ${param.valueAfter}` : "";

  return valueBefore + value + valueAfter;
};

export { getDashboard };
